import { FC } from 'react'
import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { TermoConsentimento } from '../../../core/_models'
import { getTermoById } from '../../../core/_requests'
import { RowActions, useModal } from '../../../../../../components'
import { TermoDetailModal } from '../../components/TermoDetailModal'

type Props = {
  termo: TermoConsentimento
}

export const TermosActionsCell: FC<Props> = ({ termo }) => {
  const { showModal } = useModal()

  const openDetail = () =>
    showModal({
      title: `Detalhes do Termo - Versão ${termo.versao}`,
      content: <TermoDetailModal />,
      size: ModalSize.Large,
      fetchers: { termo: () => getTermoById(Number(termo.id)) },
    })

  return (
    <RowActions
      itemName={`termo ${termo.titulo}, versão ${termo.versao}`}
      primaryAction={{ label: 'Ver detalhes', onClick: openDetail, icon: IconPaths.Search }}
    />
  )
}
